import gql from "graphql-tag";

export const LOGIN_MUTATION = gql`
  mutation($email: String!, $password: String!) {
    loginAdmin(email: $email, password: $password) {
      admin {
        email
      }
      token
      expiresAt
      status
    }
  }
`;

export const BLOCK_USER_MUTATION = gql`
  mutation($id: Int!) {
    blockUser(id: $id) {
      status
    }
  }
`;

export const UNBLOCK_USER_MUTATION = gql`
  mutation($id: Int!) {
    unblockUser(id: $id) {
      status
    }
  }
`;

export const CREATE_INVITE_CODE_MUTATION = gql`
  mutation {
    createInviteCode {
      inviteCode {
        code
      }
    }
  }
`;

export const APPROVE_FACTOR_REQUEST_MUTATION = gql`
  mutation($id: Int!) {
    approveFactorRequest(id: $id) {
      status
    }
  }
`;

export const DECLINE_FACTOR_REQUEST_MUTATION = gql`
  mutation($id: Int!) {
    declineFactorRequest(id: $id) {
      status
    }
  }
`;

export const APPROVE_BUSINESS_MUTATION = gql`
  mutation($id: Int!, $amount: Float!) {
    approveBusiness(id: $id, amount: $amount) {
      status
    }
  }
`;

export const DECLINE_BUSINESS_MUTATION = gql`
  mutation($id: Int!) {
    declineBusiness(id: $id) {
      status
    }
  }
`;

export const UPDATE_CREDIT_LIMIT_MUTATION = gql`
  mutation($businessId: Int!, $creditLimit: Float!) {
    updateCreditLimit(businessId: $businessId, creditLimit: $creditLimit) {
      status
      business {
        swipeCredit
      }
    }
  }
`;

export const DEBIT_REPAYMENT_MUTATION = gql`
  mutation($businessId: Int!, $amount: Float!) {
    debitRepayment(businessId: $businessId, amount: $amount) {
      status
      business {
        lastRepaymentAt
        accountBalance
      }
    }
  }
`;

export const UNLOCK_ACCOUNT_MUTATION = gql`
  mutation($id: Int!) {
    unlockAccount(id: $id) {
      status
    }
  }
`;
